import Immutable from 'immutable';

const initialState = Immutable.Map();

function loadLanguagesStarted(state, payload) {
  return state
    .setIn(['load', 'failed'], false)
    .setIn(['load', 'completed'], false)
    .setIn(['load', 'errors'], {})
    .set('loading', true);
}

function loadLanguagesCompleted(state, payload) {
  return state
    .set('loading', false)
    .setIn(['load', 'completed'], true)
    .setIn(['load', 'failed'], false)
    .setIn(['load', 'errors'], {})
    .set('options', payload);
}

function loadLanguagesFailed(state, payload) {
  return state
    .set('loading', false)
    .setIn(['load', 'completed'], false)
    .setIn(['load', 'failed'], true)
    .setIn(['load', 'errors'], payload.errors);
}

function loadLanguagesCached(state, payload) {
  return state
    .set('loading', false)
    .setIn(['load', 'completed'], true)
    .setIn(['load', 'failed'], false);
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        LANGUAGES_LOAD: loadLanguagesStarted,
        LANGUAGES_LOAD_COMPLETED: loadLanguagesCompleted,
        LANGUAGES_LOAD_CACHED: loadLanguagesCached,
        LANGUAGES_LOAD_FAILED: loadLanguagesFailed,
      }[type] || (() => state)
    )(state, payload);
  });
}
